export default "__VITE_ASSET__Db_qMbcm__"